import { render, staticRenderFns } from "./AudiologyKpisCard.vue?vue&type=template&id=491582de&"
import script from "./AudiologyKpisCard.vue?vue&type=script&lang=js&"
export * from "./AudiologyKpisCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('491582de')) {
      api.createRecord('491582de', component.options)
    } else {
      api.reload('491582de', component.options)
    }
    module.hot.accept("./AudiologyKpisCard.vue?vue&type=template&id=491582de&", function () {
      api.rerender('491582de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/AudiologyKpisCard.vue"
export default component.exports